export const checkoutCompleted = booking => ["paid", "reserved"].includes(booking?.status);
